import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { Upload } from '@geist-ui/icons';
import { Card, Divider, Flex, Grid, Input, Space, Title } from '@mantine/core';
import { Image as Imagecore } from '@mantine/core';
import Tesseract from 'tesseract.js';
import { useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { AutomatedAuditLoader, Button, Checkbox, TextInput } from '@common/components';
import classNames from 'classnames';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { checkImageDescription, generateDescription, getWebsiteContext, upalodImage } from 'src/store/tools';
import { useAlert } from '@common/hooks';


const ImageDescriptionChecker: React.FC = () => {
    const [image, setImage] = useState<File | null>(null);
    const [description, setDescription] = useState('');
    const [suggestedDescription, setSuggestedDescription] = useState('');
    const [feedback, setFeedback] = useState<string | null>(null);
    const [webPageUrl, setWebPageUrl] = useState('');
    const [webPageContext, setWebPageContext] = useState('');
    const [loading, setLoading] = useState(false);
    const [prevView, setPrevView] = useState('');
    const [isDragging, setIsDragging] = useState(false);

    const { showAlert } = useAlert();
    const dispatch = useAppDispatch();
    const { loadingupalodImage, 
            upalodImagekey, 
            generateDescriptionData, 
            loadinggenerateDescription, 
            loadingcheckImageDescription,
            checkImageDescriptionData,
            checkImageDescriptionError,
            upalodImageError, 
            generateDescriptionError,
            loadinggetWebsiteContext,
            getWebsiteContextData,
            getWebsiteContextError 

        } = useAppSelector((state) => state.tools, shallowEqual);

    useEffect(() => {

        setSuggestedDescription(generateDescriptionData);

    }, [generateDescriptionData])
    

    let i=0;
    const ErrorMessage = (message:any): void => {
        i = i+1;
        showAlert({
          id: message+i,
          title: 'Error',
          message: message,
          variant: 'error',
        });
      };


    useEffect(() => {
        if(checkImageDescriptionError){
            ErrorMessage(checkImageDescriptionError)
        }
        if(upalodImageError){
            ErrorMessage(upalodImageError)
        }
        if(generateDescriptionError){
            ErrorMessage(generateDescriptionError)
        }
        if(getWebsiteContextError){
            ErrorMessage(getWebsiteContextError)
        }

    }, [checkImageDescriptionError, upalodImageError, generateDescriptionError,getWebsiteContextError])

    const fetchWebPageContext = async () => {
        if (!webPageUrl) {
            alert('Please enter a URL.');
            return;
        }
            dispatch(getWebsiteContext({url:webPageUrl }));
        };
        
    useEffect(() => {
            setWebPageContext(getWebsiteContextData);

    }, [getWebsiteContextData])
    

    const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setPrevView(URL.createObjectURL(file));
            setImage(file);
            setSuggestedDescription('');
            setFeedback(null);

            dispatch(upalodImage({file }));

        }
    };

    const checkDescription = () => {
        if (description.length < 10) {
            setFeedback('Try making the description grater than 10 characters for better accessibility.');
            return;
        } 

        if(!upalodImagekey){
            alert('Please upload an image');
            return;
        }
        dispatch(checkImageDescription({ imageKey:upalodImagekey, givenDescription:description}));

    };

    

    useEffect(() => {

        setFeedback(checkImageDescriptionData);

    }, [checkImageDescriptionData])

    const suggestDescription = () => {
            if(!upalodImagekey){
                alert('Please upload an image');
                return;
            }
            dispatch(generateDescription({ imageKey:upalodImagekey, autorizeContext, webPageUrl}));

        // if (webPageContext) {
        //     setSuggestedDescription(`Suggested alt text: ${webPageContext.slice(0, 100)}...`);
        // } else {
        //     setSuggestedDescription('Suggested alt text: A scenic view of a mountain during sunset.');
        // }
    };

    const [showContext, setshowContext] = useState(false);
    const [autorizeContext, setAutorizeContext] = useState(false);
    const [contrastRatio, setContrastRatio] = useState<number | null>(null);
    const [imfFeedback, setimgFeedback] = useState<string | null>(null);

    const calculateContrast = () => {
        if (!image || !prevView) return;
    
        const img:any = new Image();
        img.src = prevView;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
    
            if (!context) return;
    
            canvas.width = img.width;
            canvas.height = img.height;
            context.drawImage(img, 0, 0);
    
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            const pixels = imageData.data;
    
            let lightPixels = 0;
            let darkPixels = 0;
    
            for (let i = 0; i < pixels.length; i += 4) {
                const r = pixels[i];
                const g = pixels[i + 1];
                const b = pixels[i + 2];
                const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    
                if (brightness > 128) {
                    lightPixels++;
                } else {
                    darkPixels++;
                }
            }
    
            const totalPixels = lightPixels + darkPixels;
            const ratio = lightPixels / totalPixels;
    
            setContrastRatio(ratio);
            setimgFeedback(
                ratio > 0.5
                    ? 'The image has sufficient color contrast.'
                    : 'The image has poor color contrast.'
            );
        };
    };

    const [ocrText, setOcrText] = useState<string | null>(null);
    const [ocrLoading, setOcrLoading] = useState(false);
    
    const extractTextFromImage = () => {
        if (!prevView) return;
    
        setOcrLoading(true);
        Tesseract.recognize(
            prevView, // Path to the image
            'eng', // Language code
            {
                logger: (info) => console.log(info), // Log progress (optional)
            }
        )
            .then(({ data: { text } }) => {
                setOcrText(text);
                setOcrLoading(false);
            })
            .catch((error) => {
                console.error('Error recognizing text:', error);
                setOcrLoading(false);
            });
    };
    
    return (
        <div style={{ backgroundColor: '#F5F7FA', width: 'calc(100% - 300px)' }}>
            <div className={styles.container_bg}>
                <Flex justify={'space-between'} direction="column">
                    <Title order={1} color="#264547" className={styles.heading}>
                        Image Description Checker
                    </Title>
                </Flex>
                <Space h="md" />
                <Divider />
                <Space h="md" />
            </div>



            <Grid mr={24} >

                <Grid.Col sm={12} md={7}  style={true? {position:'relative'}:{}} span={7} className={styles['image-checker']}>
                {
                    loadingupalodImage && ( <span className={styles['loader']}>
                        Loading ...
                        <AutomatedAuditLoader />
                        </span>
                    )
                }
                <div style={loadingupalodImage? {opacity:'0.3'} : {} }>
                    <div
                        className={`${styles['drop-zone']} ${isDragging ? styles['dragging'] : ''}`}
                        onDragOver={(e) => {
                            e.preventDefault();
                            setIsDragging(true);
                        }}
                        onDragLeave={() => setIsDragging(false)}
                        onDrop={(e) => {
                            e.preventDefault();
                            setIsDragging(false);
                            const file = e.dataTransfer?.files?.[0];
                            setPrevView(URL.createObjectURL(file));
                            setImage(file);
                        }}
                    >
                        <Input type="file" id="file-input" accept="image/*" onChange={handleImageUpload} />
                        <label htmlFor="file-input">Choose a file</label>
                        <Upload className={styles['upload-icon']} />
                        <p>Drag & drop your image here or</p>
                        {image && <p>Selected Image : {image?.name}</p>}

                        {prevView && (
                            <>
                                <Space h="sm" />
                                <div >
                                    <Imagecore src={prevView} alt="Preview" />
                                </div>
                                {/* <Space h="sm" />
                                <Button
                                    disabled={!image}
                                    className={styles['check-btn']}
                                    onClick={calculateContrast}
                                >
                                    Check Contrast
                                </Button>
                                <Button
                                    disabled={!image}
                                    className={styles['extractTextFromImage']}
                                    onClick={extractTextFromImage}
                                >
                                    {ocrLoading ? 'Checking For Text ...' : 'Check For Text'}
                                </Button> */}
                                {/* <Space h="sm" />
                                {contrastRatio !== null && (
                                    <div className={styles.feedback}>
                                        <p>Contrast Ratio: {contrastRatio.toFixed(2)}</p>
                                        <p>{feedback}</p>
                                    </div>
                                )}

                                {ocrText !== null && (
                                    <div className={styles['ocr-result']}>
                                        <p style={{display:'block',marginBottom:"10px"}} >Extracted Text:</p>
                                        <textarea
                                            style={{ width: '100%'}}
                                            value={ocrText}
                                            rows={10}
                                            readOnly
                                        />
                                        {ocrText.trim() ? (
                                            <p>The image contains text.</p>
                                        ) : (
                                            <p>No text was detected in the image.</p>
                                        )}
                                    </div>
                                )} */}
                            </>
                        )}
                    </div>


                    <div className={styles['description-area']}>
                        <textarea
                            placeholder="Enter or paste your image description here"
                            rows={5}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <Space h="md" />

                    <Checkbox
                        className={styles.notifyCheckbox}
                        label= 'Use web page URL for an improved contextual description'
                        checked={autorizeContext}
                        onChecked={(e) => setAutorizeContext(e.target.checked)}
                    />
                    <Space h="md" />

                { autorizeContext ?
                <>
                <Flex justify="space-between" >
                        <Flex align="start" gap="sm" direction="column">
                            <TextInput
                                className={styles.TextInputurl}
                                aria-label="add URL"
                                placeholder="Page URL"
                                value={webPageUrl}
                                onChange={(e) => setWebPageUrl(e.target.value)}
                            />
                            <div>
                                <Checkbox
                                        className={styles.notifyCheckbox}
                                        label= 'show webpage context block'
                                        checked={showContext}
                                        onChecked={(e) => setshowContext(e.target.checked)}
                                    />
                                <Button
                                    buttonStyle={{marginTop:"10px"}}
                                    // className={classNames(styles['action-btn'])}
                                    onClick={fetchWebPageContext}
                                    disabled={loadinggetWebsiteContext}
                                >
                                     {
                                            loadinggetWebsiteContext ? ( <span >
                                                Fetching Context...
                                                <AutomatedAuditLoader />
                                                </span>
                                            ) :
                                            'Get Context of the Webpage'
                                        }
                                </Button>
                            </div>
                        </Flex>
                    </Flex>

                    { (webPageContext && showContext) ? (
                        <div className={styles['description-area']}>
                            <Title className={styles.heading}  order={4}>Webpage Context</Title>
                            <textarea
                                style={{maxWidth:"745px"}}
                                value={webPageContext}
                                onChange={(e) => setWebPageContext(e.target.value)}
                                rows={10}
                                placeholder="Edit the context extracted from the webpage"
                            />
                        </div>
                    ) : null}
                    </> : null
                }
                
                    <Space h="md" />
                    <div className={styles['button-group']}>
                        <Button
                            disabled={!image || !description || loadingcheckImageDescription || loadinggenerateDescription}
                            ariaLabel={loadingcheckImageDescription? 'Cheking Description ...' : 'Check Description' }
                            className={styles['check-btn']}
                            onClick={checkDescription}
                        >
                             {
                                   loadingcheckImageDescription ? ( <span >
                                    Loading ...
                                    <AutomatedAuditLoader />
                                    </span>
                                ) :
                                'Check Description'
                            }
                            
                        </Button>
                        <Button
                            disabled={!image || loadinggenerateDescription || loadingcheckImageDescription}
                            color="dark-green"
                            ariaLabel={loadinggenerateDescription? 'Loading Suggest Description' : 'Suggest Description' }
                            className={styles['suggest-btn']}
                            onClick={suggestDescription}
                        >
                            {
                                  loadinggenerateDescription  ? ( <span >
                                    Loading ...
                                    <AutomatedAuditLoader />
                                    </span>
                                ) :
                                'Suggest Description'
                            }
                        </Button>
                    </div>
                    {feedback && <div className={styles.feedback}>{feedback}</div>}
                    {suggestedDescription && <div className={styles.suggestion}>{suggestedDescription}</div>}
                </div>
                </Grid.Col>

                
                <Grid.Col sm={12} md={5} span={5} p={"md"}> 
                
                <Card shadow={"sm"} p={"sm"} pt={"2rem"}>
                        <Title size={"20px"} color="#264547" order={2}>What Is Alt Text?</Title>
                        Alt text <strong>(alternative text)</strong> describes an image on a page. Alt text helps visually impaired people understand what the image shows, helps search engine bots understand image contents, and appears on a page when the image fails to load.
                    </Card>

                </Grid.Col>
            </Grid>


        </div>
    );
};

export default ImageDescriptionChecker;
